import {useCallback, useEffect, useRef, useState} from 'react'

export const DEFAULT_TOAST_DURATION_MS = 2600

/**
 * The flow's transient status message. One message shows at a time: a new
 * toast replaces the current one and restarts the clock. Messages that need
 * more reading time can pass a longer `duration` — e.g. the recording-cap
 * notice (TK-3017).
 */
const useToast = () => {
  const [toastMessage, setToastMessage] = useState(null)
  const timerRef = useRef(null)

  useEffect(() => () => clearTimeout(timerRef.current), [])

  const toast = useCallback((message, {duration = DEFAULT_TOAST_DURATION_MS} = {}) => {
    setToastMessage(message)
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setToastMessage(null), duration)
  }, [])

  return {toast, toastMessage}
}

export default useToast
